import React from "react"

const Triangle: React.FC = props => (
  <svg width={28} height={14} viewBox="0 0 28 14" {...props}>
    <path data-name="triangle" d="M14 0l14 14H0z" fill="currentColor" />
  </svg>
)

export default Triangle
